import { abyssColors } from '@/theme/colors';

export const tooltipStyles = {
  '& .MuiTooltip-tooltip': {
    backgroundColor: '#000000B8',
    color: abyssColors.primary[50],
    opacity: 1,
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    py: '1rem',
    height: '5rem',
    fontWeight: 500,
    cursor: 'pointer',
  },
  '& .MuiTooltip-arrow': {
    color: '#000000B8',
  },
};
